/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesPlanningDtosAbsencesAbsenceDaysPreviewDto,
  FacilityFlowCoreModulesPlanningDtosAbsencesAbsenceDto,
  FacilityFlowCoreModulesPlanningDtosAbsencesAbsenceListDto,
  FacilityFlowCoreModulesPlanningDtosAbsencesCreateAbsenceRequest,
  FacilityFlowCoreModulesPlanningDtosAbsencesUpdateAbsenceRequest,
  FacilityFlowCoreModulesPlanningDtosVacationVacationBalanceDto,
  GetApiV1MeAbsencesParams,
  GetApiV1MeAbsencesVacationBalanceParams,
  GetApiV1MeAbsencesWorkingDaysParams,
  PostApiV1MeAbsencesAbsenceIdCertificateBody
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getMeAbsences = () => {
/**
 * @summary The current employee's own absences, newest event first.
 */
const getApiV1MeAbsences = (
    params?: GetApiV1MeAbsencesParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosAbsencesAbsenceListDto[]>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosAbsencesAbsenceListDto[]>(
      {url: `/api/v1/me/absences`, method: 'GET',
        params
    },
      options);
    }
  const postApiV1MeAbsences = (
    facilityFlowCoreModulesPlanningDtosAbsencesCreateAbsenceRequest: FacilityFlowCoreModulesPlanningDtosAbsencesCreateAbsenceRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosAbsencesAbsenceDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosAbsencesAbsenceDto>(
      {url: `/api/v1/me/absences`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosAbsencesCreateAbsenceRequest
    },
      options);
    }
  /**
 * @summary Chargeable working days an absence of the current employee over this period would
cost — preview for the request form, same rule as when saving.
 */
const getApiV1MeAbsencesWorkingDays = (
    params?: GetApiV1MeAbsencesWorkingDaysParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosAbsencesAbsenceDaysPreviewDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosAbsencesAbsenceDaysPreviewDto>(
      {url: `/api/v1/me/absences/working-days`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary The current employee's vacation account for the vacation year containing
referenceDate (today when omitted).
 */
const getApiV1MeAbsencesVacationBalance = (
    params?: GetApiV1MeAbsencesVacationBalanceParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosVacationVacationBalanceDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosVacationVacationBalanceDto>(
      {url: `/api/v1/me/absences/vacation-balance`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Change an own request while it is still pending; a decided one →
`planning.absences.notPending` (409), someone else's → 404 (FAFD-8).
 */
const putApiV1MeAbsencesAbsenceId = (
    absenceId: string,
    facilityFlowCoreModulesPlanningDtosAbsencesUpdateAbsenceRequest: FacilityFlowCoreModulesPlanningDtosAbsencesUpdateAbsenceRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosAbsencesAbsenceDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosAbsencesAbsenceDto>(
      {url: `/api/v1/me/absences/${absenceId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosAbsencesUpdateAbsenceRequest
    },
      options);
    }
  /**
 * @summary Withdraw an own request while it is still pending; a decided one →
`planning.absences.notPending` (409), someone else's → 404 (FAFD-8).
 */
const deleteApiV1MeAbsencesAbsenceId = (
    absenceId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/me/absences/${absenceId}`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary Arztbestätigung zur eigenen Krankmeldung nachreichen — am Handy als Foto, sonst als
PDF. Ein erneuter Upload ersetzt die hinterlegte Datei. Die Krankmeldung selbst bleibt
davon unberührt und gilt auch ohne Bestätigung (ADR-0014).
 */
const postApiV1MeAbsencesAbsenceIdCertificate = (
    absenceId: string,
    postApiV1MeAbsencesAbsenceIdCertificateBody: PostApiV1MeAbsencesAbsenceIdCertificateBody,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosAbsencesAbsenceDto>>,) => {const formData = new FormData();
if(postApiV1MeAbsencesAbsenceIdCertificateBody.file !== undefined) {
 formData.append(`file`, postApiV1MeAbsencesAbsenceIdCertificateBody.file)
 }

      return customInstance<FacilityFlowCoreModulesPlanningDtosAbsencesAbsenceDto>(
      {url: `/api/v1/me/absences/${absenceId}/certificate`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  return {getApiV1MeAbsences,postApiV1MeAbsences,getApiV1MeAbsencesWorkingDays,getApiV1MeAbsencesVacationBalance,putApiV1MeAbsencesAbsenceId,deleteApiV1MeAbsencesAbsenceId,postApiV1MeAbsencesAbsenceIdCertificate}};
export type GetApiV1MeAbsencesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMeAbsences>['getApiV1MeAbsences']>>>
export type PostApiV1MeAbsencesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMeAbsences>['postApiV1MeAbsences']>>>
export type GetApiV1MeAbsencesWorkingDaysResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMeAbsences>['getApiV1MeAbsencesWorkingDays']>>>
export type GetApiV1MeAbsencesVacationBalanceResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMeAbsences>['getApiV1MeAbsencesVacationBalance']>>>
export type PutApiV1MeAbsencesAbsenceIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMeAbsences>['putApiV1MeAbsencesAbsenceId']>>>
export type DeleteApiV1MeAbsencesAbsenceIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMeAbsences>['deleteApiV1MeAbsencesAbsenceId']>>>
export type PostApiV1MeAbsencesAbsenceIdCertificateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMeAbsences>['postApiV1MeAbsencesAbsenceIdCertificate']>>>
